import {
    Container,
    Grid,
    IconButton,
    Tooltip,
    Typography,
} from "@material-ui/core";
import CustomizedMaterialTable from "components/DataTable";
import { LogRequestUserMapping } from "generated-interfaces/graphql";
import { MaterialTableProps } from "material-table";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import VisibilityIcon from "@material-ui/icons/Visibility";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import localizedFormat from "dayjs/plugin/localizedFormat";

import { getLogRequestUserMappingsSelector } from "redux/selectors/logRequestSelector";
import { LOG_REQUEST_IN_PROGRESS_STATUSES } from "utils/constants";

const LogRequestHistoryRowActions = ({
    data,
}: {
    data: LogRequestUserMapping;
}) => {
    return (
        <div>
            <Link to={`/log/${data.logRequest.id}`}>
                <Tooltip title="View Log" aria-label="View Log">
                    <IconButton>
                        <VisibilityIcon />
                    </IconButton>
                </Tooltip>
            </Link>
        </div>
    );
};

export const LogRequestHistory = () => {
    const logRequestUserMappings = useSelector(
        getLogRequestUserMappingsSelector
    );
    dayjs.extend(duration);
    dayjs.extend(relativeTime);
    dayjs.extend(localizedFormat);

    const getTimeElapsed = (data: LogRequestUserMapping) => {
        if (data.logRequest.metadata?.timeElapsedInSeconds) {
            return dayjs
                .duration(
                    data.logRequest.metadata.timeElapsedInSeconds,
                    "seconds"
                )
                .humanize();
        }

        if (LOG_REQUEST_IN_PROGRESS_STATUSES.includes(data.logRequest.status)) {
            return dayjs
                .duration(dayjs().diff(data.createdAt, "seconds"), "seconds")
                .humanize();
        }

        return "N/A";
    };

    const dataConfig: MaterialTableProps<LogRequestUserMapping> = {
        columns: [
            { title: "ID", field: "logRequest.id" },
            {
                title: "User",
                field: "user.firstName",
            },
            {
                title: "Status",
                field: "logRequest.status",
            },
            {
                title: "Restaurant Code",
                field: "logRequest.restaurantCode",
            },
            {
                title: "Mac Address",
                field: "logRequest.macAddress",
            },
            // {
            //     title: "Log From",
            //     // field: "logRequest.timeStartAt",
            //     render: (data) => {
            //         return dayjs(Number(data.logRequest.timeStartAt)).format();
            //     },
            // },
            // {
            //     title: "Log To",
            //     field: "logRequest.createdAt",
            // },
            // {
            //     title: "Time Elapsed",
            //     render: (data) => {
            //     },
            // },
            {
                title: "Actions",
                render: (data) => {
                    return <LogRequestHistoryRowActions data={data} />;
                },
            },
        ],
        data: logRequestUserMappings.map((logRequestUserMapping) => ({
            ...logRequestUserMapping,
        })),
        onRowClick: (event, rowData, togglePanel) => {
            if (togglePanel) togglePanel();
        },
        detailPanel: (data) => {
            return (
                <Container>
                    <Typography>
                        Log start at -{" "}
                        {dayjs(Number(data.logRequest.timeStartAt)).format(
                            "lll"
                        )}
                    </Typography>
                    <Typography>
                        Log end at -{" "}
                        {dayjs(data.logRequest.createdAt).format("lll")}
                    </Typography>
                    <Typography>
                        Time elapsed - {getTimeElapsed(data)}
                    </Typography>
                    {!!data.logRequest.metadata?.logUploadTimeDiffInSeconds && (
                        <Typography>
                            Time took to upload logs -{" "}
                            {dayjs
                                .duration(
                                    data.logRequest.metadata
                                        .logUploadTimeDiffInSeconds,
                                    "seconds"
                                )
                                .humanize()}
                        </Typography>
                    )}
                    {!!data.logRequest.metadata?.logProcessingTimeInSeconds && (
                        <Typography>
                            Time took to process logs -{" "}
                            {dayjs
                                .duration(
                                    data.logRequest.metadata
                                        .logProcessingTimeInSeconds,
                                    "seconds"
                                )
                                .humanize()}
                        </Typography>
                    )}
                    {!!data.logRequest.metadata?.failedReason && (
                        <Typography>
                            Failed reason -{" "}
                            {data.logRequest.metadata.failedReason}
                        </Typography>
                    )}
                </Container>
            );
        },
    };

    return (
        <Container>
            <Typography variant="h3">Log Request History</Typography>
            <Grid item xs={12}>
                <CustomizedMaterialTable {...dataConfig} />
            </Grid>
        </Container>
    );
};
